import { ElButton, ElIcon, ElInput, ElTooltip, isEmpty, TextareaRef } from '@qsxy/element-plus-react';
import classNames from 'classnames';
import { useRef, useState } from 'react';

interface Props {
	disabled?: boolean; // 禁用状态
	send?: (message: string) => void;
}

const ChatInput = ({ disabled, send }: Props) => {
	// 输入内容
	const [message, setMessage] = useState('');
	const [isColumn, setIsColumn] = useState(false);
	const textareaRef = useRef<TextareaRef>(null);
	const divhidden = useRef<HTMLDivElement>(null);

	// 发送消息处理
	const handleSend = () => {
		const trimmedMessage = message.trim();
		if (!trimmedMessage || disabled) {
			return;
		}

		send?.(trimmedMessage);
		setMessage('');
		textareaRef.current.input.style.height = '21px';
		setIsColumn(false);
	};

	function autoTextarea() {
		if (divhidden.current) {
			divhidden.current.innerHTML = '<pre>' + message + ' ' + '</pre>';
			let height = divhidden.current.offsetHeight;
			if (height > 192) {
				height = 192;
			} else {
				height = height <= 21 ? 21 : height;
			}
			setIsColumn(height > 21);
			textareaRef.current.input.style.height = height + 'px';
		}
	}

	return (
		<>
			<div className="ttn-chat-input">
				<div className={classNames('flex', { 'is-column': isColumn })}>
					<ElInput.TextArea
						ref={textareaRef}
						value={message}
						plain
						rows={1}
						placeholder="在此输入您的问题"
						onChange={(value: string) => setMessage(value)}
						onKeyUp={event => {
							autoTextarea();
							if (event.key === 'Enter') {
								event.preventDefault();
								handleSend();
							}
						}}
					></ElInput.TextArea>
					<div className="operation">
						{/* <div className="left">
						<ElSwitch value={deep} size="small" activeText="长思考" activeValue={true} inactiveValue={false} onChange={(value: boolean) => setDeep(value)} />
					</div> */}
						<div className="right">
							{/* {type === 'all' && !deep ? (
							<ElUpload className="el-button" style={{ padding: 0 }} action="#" accept={accept} showFileList={false} beforeUpload={beforeUpload}>
								<ElTooltip
									content="支持PDF, Word, PPT 或 图片文件（最大15MB）上传至个人知识库，当前剩余41.80 MB可用空间"
									effect="grey"
									placement="top"
									popperStyle={{ maxWidth: 400 }}
								>
									<ElButton>
										<ElIcon prefix="fas" name="cloud-arrow-up" size="2x" />
									</ElButton>
								</ElTooltip>
							</ElUpload>
						) : null} */}
							<ElTooltip content={isEmpty(message) ? '请输入问题' : '发送消息'} effect="grey" placement="top">
								<ElButton className={classNames({ 'is-disabled': isEmpty(message) || disabled })} onClick={handleSend}>
									<ElIcon className="active" prefix="fas" name="paper-plane" size="2x" />
								</ElButton>
							</ElTooltip>
						</div>
					</div>
				</div>
			</div>
			<div className="ttn-chat-hidden-div" ref={divhidden}></div>
		</>
		// <div className="ttn-chat-input">
		// 	<div className="input-wrapper">
		// 		<ElInput.TextArea
		// 			value={message}
		// 			onChange={(value: string) => setMessage(value)}
		// 			maxLength={2000}
		// 			// autosize={{ minRows: 1, maxRows: 4 }}
		// 			showWordLimit
		// 			placeholder="输入您的问题..."
		// 			onKeyUp={event => {
		// 				if (event.key === 'Enter') {
		// 					handleSend();
		// 				}
		// 			}}
		// 			disabled={disabled}
		// 			className="custom-input is-active"
		// 		/>
		// 		<ElButton type="primary" loading={disabled} onClick={handleSend} disabled={!message.trim()} className="send-button">
		// 			发送
		// 		</ElButton>
		// 	</div>
		// </div>
	);
};

export default ChatInput;
